<span [class]="cssClass">{{ label }}</span>
